export default class Utils {
  /**
   * Returns a Date object with UTC time zone, with exact same Year, Month, Day, Hour, Minute and Second.
   * Note that this will not convert given Date object to UTC, but rather strip the timezone.
   *
   * @param date Local Date object.
   */

  static toUtcDate(date: Date): Date {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ),
    );
  }

  static shouldUpdateNumericForm(formValue?: number, value?: number) {
    return (this.isNumericValue(formValue) || this.isNumericValue(value)) && formValue !== value;
  }

  static shouldUpdateStringForm(formValue?: string, value?: string) {
    return (this.hasValue(formValue) || this.hasValue(value)) && formValue !== value;
  }

  static hasValue(value?: string) {
    return value !== null && value !== undefined;
  }

  static isNumericValue(value?: number) {
    return value !== null && value !== undefined && !isNaN(value);
  }
}
